export const SIGNIN = "https://accounts.paybrise.app/"
export const SIGNUP = "https://accounts.paybrise.app/signup/"